/* eslint-disable no-undef */
import React from 'react'
import { makeStyles } from '@mui/styles'

import config from '@/config'
import lang from '@/lang'

const PublicAccessLayout = () => {
  const classes = useStyles()
  const { agbUrl, imprintUrl, privacyUrl, customerSupport } = config

  return (
    <footer className={classes.sidebarFooter}>
      <div>
        <a href={imprintUrl} target="_blank" rel="noopener noreferrer" className={classes.footerLink}>{lang.imprint}</a>
        <span className={classes.seperator}>|</span>
        <a href={agbUrl} target="_blank" rel="noopener noreferrer" className={classes.footerLink}>
          {lang.termsOfConditons}
        </a>
        &nbsp;&&nbsp;
        <a href={privacyUrl} target="_blank" rel="noopener noreferrer" className={classes.footerLink}>
          {lang.privacy}
        </a>
      </div>
      <div>
        <a href={customerSupport} target="_blank" rel="noopener noreferrer" className={classes.footerLink}>{lang.customerSupport}</a>
        <span className={classes.seperator}>|</span>
        <a className={classes.footerLink} onClick={() => UC_UI?.showSecondLayer()}>
          {lang.onboarding.general.cookies}
        </a>
      </div>
    </footer>
  )
}

const useStyles = makeStyles((theme) => ({
  sidebarFooter: {
    color: theme.navSubmenuImprintItemColorLight,
    fontSize: theme.auth.sidebar.footer.link.fontSize,
    letterSpacing: '0.2px',
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      whiteSpace: 'nowrap',
    },
  },
  footerLink: {
    color: theme.navSubmenuImprintItemColorLight,
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:link': {
      color: theme.navSubmenuImprintItemColorLight,
    },
    '&:visited': {
      color: theme.navSubmenuImprintItemColorLight,
    },
  },
  seperator: {
    color: theme.navSubmenuImprintItemColorLight,
    display: 'inline-block',
    padding: '0 4px',
  },
}))
export default PublicAccessLayout
